module.exports = __webpack_public_path__ + "img/www.cargurus.com.364bad4e.png";